import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../lib/router/withRouter';
import { VERSION_DETAIL_PAGE_TYPE, VERSION_PAGE_NAME } from '../../constants/service/app/versionConstants';
import VersionDetailContainer from '../../containers/version/VersionDetailContainer';
import PageTemplate from '../../components/template/PageTemplate/PageTemplate';
import { versionActions } from '../../store/modules/version';

class VersionEdit extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  initiate = (versionId) => {
    const { getVersionInfo } = this.props;
    getVersionInfo({ versionId });
  };

  render() {
    const { editVersion } = this.props;

    return (
      <PageTemplate pageName={VERSION_PAGE_NAME.VERSION_EDIT}>
        <VersionDetailContainer pageType={VERSION_DETAIL_PAGE_TYPE.EDIT} onSubmit={editVersion} />
      </PageTemplate>
    );
  }
}

const mapDispatchToProps = {
  getVersionInfo: versionActions.getVersionInfo,
  editVersion: versionActions.editVersion,
};

export default connect(null, mapDispatchToProps)(withRouter(VersionEdit));
